import DateUtils from '../inumet_js_lib/utils/dateUtils.js'

const MAX_HORAS_PRONOSTICO = 96

function getSerieEtTiempo(fechaInicio) {
    let fechas = []
    let fechaAux = fechaInicio
    for (let i = 0; i < MAX_HORAS_PRONOSTICO; i++) {
        if (i % 24 === 0)
            fechas.push(
                DateUtils.getDay(fechaAux) + '/' + DateUtils.getMonth(fechaAux)
            )
        else fechas.push(DateUtils.getHour(fechaAux))
        fechaAux = DateUtils.addHours(fechaAux, 3)
    }
    return fechas
}

function getMaxValueChart(data, margin) {
    let max = 0
    data.forEach((x) => {
        if (x > max) max = x
    })
    return max + margin
}

function getChartDataViento(puerto, data, fechaInicio) {
    if (puerto && data && fechaInicio) {
        return {
            series: [
                {
                    name: puerto + ' Viento',
                    data,
                },
            ],
            options: {
                chart: {
                    height: '1130',

                    type: 'line',
                    dropShadow: {
                        enabled: true,
                        color: '#000',
                        top: 18,
                        left: 7,

                        blur: 10,
                        opacity: 0.2,
                    },
                    toolbar: {
                        show: false,
                    },
                },
                colors: ['#77B6EA'],
                dataLabels: {
                    enabled: true,
                },
                stroke: {
                    curve: 'smooth',
                },
                title: {
                    text: 'Viento en superficie2',
                    align: 'left',
                },
                grid: {
                    borderColor: '#e7e7e7',
                    row: {
                        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5,
                    },
                },
                markers: {
                    size: 1,
                },
                xaxis: {
                    categories: getSerieEtTiempo(fechaInicio),
                    title: {
                        text: 'Horas',
                    },
                },
                yaxis: {
                    title: {
                        text: 'kt',
                    },
                    min: 0,

                    max: getMaxValueChart(data, 5),
                },
            },
        }
    }
    return null
}

const selectSerie = function (variables, nombre) {
    let itemVars = variables.find((itemVariables) => {
        return itemVariables.Nombre === nombre
    })
    if (itemVars) {
        return itemVars.data
    }
    return null
}

export { getChartDataViento, selectSerie }
